import { render, staticRenderFns } from "./costHelpThirtyTage.vue?vue&type=template&id=e98c883a&"
import script from "./costHelpThirtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpThirtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e98c883a')) {
      api.createRecord('e98c883a', component.options)
    } else {
      api.reload('e98c883a', component.options)
    }
    module.hot.accept("./costHelpThirtyTage.vue?vue&type=template&id=e98c883a&", function () {
      api.rerender('e98c883a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SqYtVAP1mkdl/JS/costHelpThirtyTage.vue"
export default component.exports